import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/common/Navbar";

export default function MainLayout() {
  return (
    <div>
      <Navbar >
        <div className="flex-1">
          <div className="p-6 flex flex-col justify-between space-y-6">
            <Outlet />
          </div>
        </div>
      </Navbar>
    </div>
  );
}
